"use client";
import { CentiLogo } from "@/components";
import ErrorPage from "@/components/organisms/error";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body className="p-6">
        <CentiLogo />
        <ErrorPage error={error} />
      </body>
    </html>
  );
}
